export const whiteSpace = {
  normal: "whitespace-normal",
  nowrap: "whitespace-nowrap",
  pre: "whitespace-pre",
  preLine: "whitespace-pre-line",
  preWrap: "whitespace-pre-wrap",
}

export type WhiteSpace = keyof typeof whiteSpace
